import React from 'react'
import {
  Box,
  Grid,
  styled,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import { chunk, compact, includes, isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { PointChecked, PointUnchecked, WarnIcon } from '../../icons'

const TitleBar = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 0, 2),
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover,
  },
  '& td, & th': {
    padding: theme.spacing(1),
    border: 0,
  },
}))

function TechnicalConditionList({ digitalCertificate, groupIds }) {
  const { technicalConditions } = digitalCertificate

  const groups = compact(
    map(technicalConditions.getTechnicalConditionGroupModel, (group) => {
      if (includes(groupIds, group.technicalChecklistGroupId)) {
        return group
      }
      return null
    }),
  )

  return (
    <>
      {map(groups, (group, gkey) => {
        const columns = chunk(
          group.technicalChecklistGroupElements,
          Math.ceil(group.technicalChecklistGroupElements.length / 2),
        )
        return (
          <Box key={gkey}>
            <TitleBar variant="h3">
              {group.technicalChecklistGroupName}
            </TitleBar>
            <Grid container spacing={0}>
              {map(columns, (column, ck) => (
                <Grid key={ck} item xs={6}>
                  <Table>
                    <TableBody>
                      {map(column, (item, ik) => (
                        <StyledTableRow key={ik}>
                          <TableCell>
                            <Typography
                              variant="body2"
                              sx={{
                                display: 'flex',
                                alignItems: 'strech',
                                minHeight: 32,
                                lineHeight: 1.1,
                              }}
                            >
                              <Box
                                component="span"
                                sx={({ palette }) => ({
                                  color:
                                    (item.technicalConditionStatus === 'Ok' &&
                                      palette.success.main) ||
                                    (item.technicalConditionStatus ===
                                      'NotOk' &&
                                      palette.warning.main) ||
                                    (item.technicalConditionStatus ===
                                      'NotApplicable' &&
                                      palette.text.disabled),
                                })}
                              >
                                {item.technicalConditionStatus === 'Ok' && (
                                  <PointChecked />
                                )}
                                {item.technicalConditionStatus === 'NotOk' && (
                                  <WarnIcon />
                                )}
                                {item.technicalConditionStatus ===
                                  'NotApplicable' && <PointUnchecked />}
                              </Box>
                              <Box component="span" sx={{ ml: 1 }}>
                                {item.technicalChecklistItemName}
                                <br />
                                {item.technicalConditionStatus === 'NotOk' &&
                                  !isEmpty(item.description) && (
                                    <Typography
                                      variant="caption"
                                      sx={({ palette }) => ({
                                        color: palette.text.disabled,
                                      })}
                                    >
                                      {item.description}
                                    </Typography>
                                  )}
                              </Box>
                            </Typography>
                          </TableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
              ))}
            </Grid>
          </Box>
        )
      })}
    </>
  )
}

TechnicalConditionList.propTypes = {
  digitalCertificate: PropTypes.object,
  groupIds: PropTypes.array,
}

TechnicalConditionList.defaultProps = {
  digitalCertificate: {},
  groupIds: [],
}

export default TechnicalConditionList
